
import Vue from 'vue'
import { mapGetters } from 'vuex'
import UserActivity from '@/components/stats/UserActivity.vue'

export default Vue.extend({
  name: 'DashboardUserActivity',
  components: { UserActivity },
  methods: {},
  computed: {
    ...mapGetters({
      user: 'user/user',
    }),
  },
})
